<template>
  <div>
    <div class="search-padding">
      <input
        class="input is-rounded"
        type="text"
        placeholder="Search Fosters"
        v-model="search"
      >
    </div>
    <!--Foster Grid-->
    <div class="container">
      <div class="columns is-multiline">
        <div
          class="column is-one-quarter"
          v-for="post of fosterResults"
          :key="post.id"
        >
          <div class="card">
            <div class="card-image">
              <figure class="image is-4by3">
                <img
                  :src="post.better_featured_image.source_url"
                  alt="Placeholder image"
                >
              </figure>
            </div>
            <div class="card-header">
              <div class="media-content">
              <p class="title is-4 title-padding">{{post.title.rendered}}</p>
              <p class="subtitle is-6 title-padding">{{post.foster_type}}</p>
              </div>
            </div>
            <div class="card-content">
              <div class="level tags">
              <span class="level-item tag is-rounded">{{post.foster_gender}}</span>
              <span class="level-item tag is-rounded">{{post.foster_age}}</span>
              <span class="level-item tag is-rounded">{{post.foster_size}}</span>
              </div>
              <div> {{post['wpcf-beagle-info-story'] | truncate}}</div>
            </div>

            <footer class="card-footer">
              <a
                href="#"
                class="card-footer-item"
              >More Details</a>
              <!-- <a
                href="#"
                class="card-footer-item"
              >My Story</a> -->
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-padding {
  padding: 2rem;
}
.title-padding {
  padding-left: 1rem;
}
</style>


<script>
import axios from 'axios';

export default {
  data() {
    return {
      posts: [],
      errors: [],
      search: '',
    };
  },

  // Fetches posts when the component is created.
  async created() {
    try {
      const response = await axios.get('http://www.staging2.tribeagles.org/wp-json/wp/v2/fosters');
      this.posts = response.data;
    } catch (e) {
      this.errors.push(e);
    }
  },
  computed: {
    fosterResults() {
      // Filter Fosters
      return this.posts.filter(post =>
        post.title.rendered.toUpperCase().includes(this.search.toUpperCase()));
    },
  },
  filters: {
    truncate(value) {
      if (value.length > 100) {
        // eslint-disable-next-line no-param-reassign
        value = `${value.substring(0, 90)}...`;
      }


      return value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/our-fosters.vue